import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import Card from '../../core/components/Card'
import i18n from '../i18n'
import style from './PatrimonyCard.less'

class PatrimonyCard extends Component {
    static propTypes = {
        patrimony: PropTypes.object.isRequired
    }

    render() {
        const {patrimony, ...others} = this.props

        const header = (
            <h5>{i18n.patrimony} <small>n° {patrimony.ref}</small></h5>
        )

        const address = (address) => {
            return address && (
                <div>
                    {address.quality && (
                        <span>{address.quality} - </span>
                    )}
                    <span>{address.number} {address.street} - </span>
                    <span>{address.zipCode} {address.city}</span>
                </div>
            )
        }

        return (
            <div className={style.default}>
                <Card justified
                    kind='tab'
                    header={header}
                    {...others}>
                        <div className={style.label}>
                            <h5>> {patrimony.label}</h5>
                        </div>
                        <div className={style.address}>
                            <h5>{i18n.address}</h5>
                            {address([...patrimony.addresses, ...patrimony.complementaryAddresses][0])}
                        </div>
                </Card>
            </div>
        )
    }
}

export default PatrimonyCard


// WEBPACK FOOTER //
// ./lib/patrimony/components/PatrimonyCard.js